
import axios from 'axios';
import moment from 'moment';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    take : 10,
    columns: [
        {
            key : "kooi_id",
            label : "kooi_id",
            setable: false,
            class: "is-2 has-text-right",
            html : false,
            display : true
        },
        {
            key : "invoice_number",
            label: "inv_number",
            html : false,
            display : true
        },
        {
            key : "total_brutto",
            label: "total_brutto",
            class: "text-right",
            html : false,
            display : true,
            type: "decimal",
            digits: null
        },
        {
            key : "currency.symbol",
            label: "currency",
            class: "has-text-right",
            html : false,
            display : true
        },
        {
            key : "invoice_due_date",
            label : "inv_duedate",
            html : false,
            display : true,
            type: "date",
            format: null
        },
        {
            key : "status",
            label : "status",
            html : true,
            display : true
        },
    ],
    loaded : false,
    loadingMore: false,
    allLoaded : false,
    addNew : false,
    workingOn: [],
    error: false,
})

  // getters
  const getters = {
      isWorkingOn : (state) => (id) => {
          var index = state.workingOn.findIndex(id);
          if(index >= 0){
              return true;
          }else{
              return false;
          }
      }
  }

  // actions
  const actions = {
    async load({commit, state, rootState}){
        if(state.allLoaded == false){
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/dashboard/invoices", {params: {skip: state.list.length, take:state.take}}).then((response) => {
                commit("set", response.data.data);
                commit("loaded", false);
                commit("setError", false);
            }).catch(function(error){
                console.log(error.toJSON());
                commit("setError", true);
            })
        }
    },
  }

  // mutations
  const mutations = {
    clean(state){
        state.allLoaded = false;
        state.list = [];
        state.loaded = false;
        state.workingOn = [];
      },
      setError(state, status){
          state.error = status;
      },
      subLoading(state, mail){
          var index = state.workingOn.findIndex(item => item = mail.id);
          if(index >= 0){
              state.workingOn.splice(index, 1);
          }else{
              state.workingOn.push(mail.id);
          }
      },
      newMail(state, mail){
        state.list.unshift(mail);
      },
      update(state, mail){
        var index = state.list.findIndex(item => item.id == mail.id);
        if(index >= 0){
            state.list[index] = mail;
        }
        else{
            state.list.unshift(mail);
        }
        },
      set(state, list){
          if(list == undefined || list.length <= 0){
            state.allLoaded = true;
          }
          for (var i = 0; i < list.length; i++) {
            // due date
            var duedate = new Date(list[i]["invoice_due_date"]);
            list[i]["invoice_due_date"] = moment(duedate).format("YYYY-MM-DD");

            // status
            if (list[i]["status"] == "paid") {
                list[i]["status"] = '<span class="inline-flex items-center justify-center px-2 py-1 text-base leading-none text-green-100 bg-green-700 rounded">'+list[i]["status"]+'</span>';
            }else if (list[i]["status"] == "overdue") {
                list[i]["status"] = '<span class="inline-flex items-center justify-center px-2 py-1 text-base leading-none text-red-100 bg-red-700 rounded">'+list[i]["status"]+'</span>';
            }else{
                list[i]["status"] = '<span class="inline-flex items-center justify-center px-2 py-1 text-base leading-none text-white bg-gray-400 rounded">'+list[i]["status"]+'</span>';
            }
          }
          state.list.push(...list);
      },
      remove(state, mail){
          var index = state.list.findIndex(item => item.id == mail.id);
          if(index >= 0){
              state.list.splice(index, 1);
          }
      },
      loaded(state, status){
          state.loadingMore = status;
          state.loading = status;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
